import { render, staticRenderFns } from "./bgVolume.vue?vue&type=template&id=1958af47&scoped=true&"
import script from "./bgVolume.vue?vue&type=script&lang=ts&"
export * from "./bgVolume.vue?vue&type=script&lang=ts&"
import style0 from "./bgVolume.vue?vue&type=style&index=0&id=1958af47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1958af47",
  null
  
)

export default component.exports